import React, { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'hooks';
import config from 'controllers/config';
import MUIDataTable, { Responsive } from 'mui-datatables';
//import { OptionsDefault } from 'components/util/optionsTabelaDefault/.mixins';
import { useApi } from 'services/api';
import { controlledFetch } from 'utils/http';
import { CircularProgress } from '@material-ui/core';
import { AxiosRequestConfig } from 'axios';
import Cookies from 'universal-cookie';
import { useEditFormContext } from 'pages/formsCreate/context';
import { tableHeaders } from './const';
import { ISupplierContact } from 'pages/formsCreate/types';
import { CustomToolbar } from './CustomToolbar';

export const SelectSuppliersTable = () => {
  const { toggleSnackbar } = useSnackbar();
  const { selectedSuppliers, setSelectedSuppliers } = useEditFormContext();
  const { api } = useApi();

  const [supplierType, setSupplierType] = useState<string>('F');
  const handleSupplierTypes = (event: React.ChangeEvent<{ value: unknown }>) => {
    setSupplierType(event.target.value as string);
  };

  const [suppliersContactList, setSuppliersContactList] = useState<ISupplierContact[]>([]);
  const [suppliersContactLoading, setSuppliersContactLoading] = useState(false);
  const getSuppliers = useCallback(async () => {
    const backendUrl = config.URL_BACKEND;
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    if (backendUrl) {
      const params = { tipo: supplierType };
      const headers = { userfunctionkey: '3416a75f4cea9109507cacd8e2f2aefc', 'User-Token': token };
      const { data } = await api.get<{ itens: ISupplierContact[] }>(`${backendUrl}/fornecedores`, {
        headers,
        params
      } as AxiosRequestConfig<any>);
      return data;
    }
  }, [supplierType, api]);

  const controlledGetSuppliers = controlledFetch(getSuppliers);

  const loadSuppliersContact = useCallback(async () => {
    setSuppliersContactLoading(true);
    await controlledGetSuppliers()
      .then((data) => {
        if (!data) return;

        if (!selectedSuppliers.length) {
          const ids = data.itens.map(({ ID_PESSOA }) => Number(ID_PESSOA));
          setSelectedSuppliers(ids);
        }
        setSuppliersContactList(data.itens);
      })
      .catch(() => {
        toggleSnackbar({
          message: 'Erro ao carregar fornecedores',
          type: 'error'
        });
      })
      .finally(() => {
        setSuppliersContactLoading(false);
      });
  }, [controlledGetSuppliers, selectedSuppliers]);

  const handleSelectSuppliers = (supplierId: string) => {
    const isSelected = selectedSuppliers.some((item) => item === Number(supplierId));
    if (isSelected) {
      setSelectedSuppliers(selectedSuppliers.filter((item) => item !== Number(supplierId)));
    } else {
      setSelectedSuppliers((prev) => [...prev, Number(supplierId)]);
    }
  };

  useEffect(() => {
    loadSuppliersContact();
  }, [supplierType]);

  if (suppliersContactLoading)
    return (
      <div>
        <CircularProgress />
      </div>
    );
  return (
    <>
      <MUIDataTable
        columns={tableHeaders({ suppliersContactList, handleSelectSuppliers, selectedSuppliers })}
        data={suppliersContactList}
        title="Fornecedores"
        options={{
          download: false,
          print: false,
          viewColumns: false,
          selectableRows: 'none',
          selectableRowsHeader: false,
          rowsPerPage: 10,
          rowsPerPageOptions: [10, 25, 50, 75, 100, 200],
          responsive: 'scrollFullHeight' as unknown as Responsive,
          selectToolbarPlacement: 'none',
          customToolbar: () => (
            <CustomToolbar
              handleSupplierTypes={handleSupplierTypes}
              supplierType={supplierType}
              suppliersData={suppliersContactList}
            />
          )
        }}
      />
    </>
  );
};
